import api from "../..";
import { uploadFile } from "../../file/uploadFile";
import type { SignRequestBody } from "../../file/types";
import type { Video, PatchVideoBody, PatchVideoParams } from "./types";

export const patchVideo = async ({ uuid, originalVideo, description, videoFile, coverFile }: PatchVideoParams): Promise<boolean> => {

  const body: PatchVideoBody = {};

  if (description !== originalVideo.description) {
    body.description = description;
  }

  if (videoFile) {
    const signBody: SignRequestBody = {
      item_type: "course",
      item_id: Date.now(),
      object_name: videoFile.name,
      object_type: "video",
      object_size: videoFile.size,
    };

    body.content = await uploadFile({
      file: videoFile,
      signBody,
    });
  }

  if (coverFile) {
    const signBody: SignRequestBody = {
      item_type: "course",
      item_id: Date.now(),
      object_name: coverFile.name,
      object_type: "image",
      object_size: coverFile.size,
    };

    body.cover_image = await uploadFile({
      file: coverFile,
      signBody,
    });
  }

  return await api.patch(`/admin/video/${uuid}/`, body)
  .then(() => true)
  .catch(() => false);
};